export default function getSfPortalConnector(store) {
  return event => {
    if (event?.type) {
      store.dispatch(event);
    }
  };
}
